import React from "react";

const VerticalLine = () => {
  return (
    <span className="logo-background-color h-[75%] min-w-[10px] max-w-[10px] rounded-md"></span>
  );
};

export default VerticalLine;
